import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import EmpSuccess from "../employees/employeeSuccess";
import { createNewFinancers, updateFinancer } from "../../../apis/financers";
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts";
import { ChangeStatus, uploadFile } from "../../../apis/auth";
import {
  getAllNationalsDistributor,
  getAllNationalsFinancer,
} from "../../../apis/nationals";
import Select from "react-select";
import { getAllPlans } from "../../../apis/plans";
import { getVerifiedData } from "../../../apis/discount";
import RenderRazorpay from "../../../razorpay";
import CommonSearch from "../commonSearch";
import { Moment } from "moment";
import { API_BASE_URL, formatDate } from "../../../environment";
import axios from "axios";
import Newloader from "../employees/loader";
type PasswordField = "password" | "confirmPassword";

const FinancersList = () => {
  const initialValues = {
    full_name: "",
    user_name: "",
    email: "",
    password: "",
    confirm_password: "",
    phone_number: "",
    prefix_code: "",
    company: "",
    about: "",
    geo_location: "",
    company_name: "",
    cin_number: "",
    pan_number: "",
    gst_no: "",
  };
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;
  const addressState = {
    addressLine: "",
    city: "",
    states: "",
    country: "",
    pincode: "",
  };
  const [address, setAddress] = useState(addressState);
  const { city, states, country, pincode, addressLine } = address;
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [filteredData, setFilteredData] = useState<EmployeeData[]>([]);
  const [allPlans, setAllPlans] = useState<PlanData[]>([]);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [selectedPlans, setSelectedPlans] = useState<any>();
  const [newSelectedOption, setNewSelectedOption] = useState<any>();
  const [selecteddisOption, setSelectedDisOption] = useState<any>();
  const [coupon_code, setCoupon_Code] = useState<string>("");
  const [voucher_code, setVoucher_Code] = useState<string>("");
  const [coupon_btn, setCoupo_btn] = useState<boolean>(false);
  const [coupon_btn1, setVoucher_btn] = useState<boolean>(false);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const departNational = [{ value: "distributors", label: "Distributors" }];
  const [departSD, setSD] = useState<any>([]);
  const [error, setError] = useState<string>("");
  const mtIdString = sessionStorage.getItem("info");
  const [cheque_img, setCheque_img] = useState<any>();
  let mtId: { id: string; user_id: string } | null = null;
  const userType = JSON.parse(mtIdString).type;
  const {
    full_name,
    user_name,
    email,
    company_name,
    cin_number,
    password,
    pan_number,
    confirm_password,
    phone_number,
    prefix_code,
    gst_no,
  } = formData;

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }

      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
      }
    }
  };
  const handleChequeFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setCheque_img(response.data.image);
      }
    }
  };
  const handleCancel = () => {
    setImage(null);

    setError("");
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };
  type EmployeeResponse = {
    createdAt: string;
    full_name: string;
    address: string;
    geo_location: string;
    profile_pic: string;
    email: string;
    phone_number: string;
    distributer_id: number;
    plan: any;
    Status: string;
    user: any;
    id: any;
    company_name: string;
  };

  type EmployeeData = {
    key: string;
    Name: string;
    Image: string;
    address: string;
    Email: string;
    Phone: string;
    distributer_id: string;
    Status: string;
    planDetail: any;
    id: any;
    allDetails: any;
    company_name: string;
  };
  const [loader, setLoader] = useState(false);
  const fetchAllEmployees = async () => {
    setLoader(true);
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllNationalsFinancer(data);
      const employeeData = response?.data?.financerAllData?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          id: item.id,
          CreatedAt: formatDate(item.createdAt),
          company_name: item.company_name,
          Name: `${item.full_name}`,
          Email: item.email || "--",
          Phone: item.phone_number || "--",
          address: (() => {
            try {
              const parsed = JSON.parse(item.address);
              return `${parsed.addressLine || ""}, ${parsed.city || ""}, ${parsed.states || ""
                }, ${parsed.country || ""} - ${parsed.pincode || ""}`;
            } catch {
              return "--";
            }
          })(),
          Image: item.profile_pic ? item.profile_pic : "--",
          Status: item?.user?.status || "--",
          planDetail: item.plan ? item.plan : "--",
          distributer_id: `${item.distributer_id}` || "--",
          allDetails: item,
        })
      );
      setEmployeeData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };
  interface National {
    id: string;
    full_name: string;
  }

  const getAllDistributor = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsDistributor(data);
    const filteredData = response?.data?.distributorData;
    setSD(
      filteredData.map((ele: National) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  type PlanData = {
    label: number;
    value: string;
  };
  type PlanResponse = {
    plan_name: string;
    id: string;
  };

  const [totalAmount, setTotalAmount] = useState<any>();
  const [discountedTotal, setDiscountedTotal] = useState<any>(0);
  const [voucherDiscountedTotal, setVoucherDiscountedTotal] = useState<any>(0);
  const [selectPaymentType, setSelectPaymentType] = useState<any>();
  const [cheque_no, setCheque_no] = useState<any>();
  const [cheque_date, setCheque_date] = useState<any>();

  const handlePaymentType = (option: any | null) => {
    setSelectPaymentType(option || []);
  };
  const handlepSelect = (option: any | null) => {
    setTotalAmount(undefined);
    setDiscountedTotal(undefined);
    setCoupon_Code("");
    setSelectedPlans(option);
    setSelectedOption(option || undefined);
    const amount =
      Number(option?.item?.amount) + Number(option?.item?.subscribe_amount);
    setTotalAmount(amount);
  };
  const handleNewSelect = (option: any | null) => {
    setSelectedDisOption(option || undefined);
    const newResponse = allEmployeeData.filter((ele, i) => {
      return Number(ele.distributer_id) === Number(option?.value);
    });
    setFilteredData(newResponse);
  };
  const handleSelectDis = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setDiscountedTotal(undefined);
    const { name, value } = e.target;
    setCoupon_Code(value);
    setCoupo_btn(true);
  };
  const handleSelectVoucherDis = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setVoucherDiscountedTotal(undefined);
    const { name, value } = e.target;
    setVoucher_Code(value);
    setVoucher_btn(true);
  };
  const [discountData, setDiscountData] = useState<any>();
  const [voucherData, setVoucherData] = useState<any>();
  const handleVerifyCode = async (event: any) => {
    event.preventDefault();
    try {
      const response = await getVerifiedData(coupon_code, 0);
      if (response.status === true) {
        successAlert("success", "validate");
        const { amount, percentage } = response.data;
        let finalTotal = totalAmount;
        if (percentage && percentage > 0) {
          finalTotal = totalAmount - (totalAmount * percentage) / 100;
        } else if (amount && amount > 0) {
          finalTotal = totalAmount - amount;
        }
        finalTotal = Math.max(finalTotal, 0);
        setDiscountedTotal(finalTotal);
        setDiscountData(response.data);
        setCoupo_btn(false);
      }
    } catch (error) {
      errorAlert("invalid code");
    }
  };
  const handleVerifyVoucherCode = async (event: any) => {
    event.preventDefault();
    try {
      const response = await getVerifiedData(voucher_code, 1);
      if (response.status === true) {
        successAlert("success", "validate");
        const { amount } = response.data;
        let finalTotal = discountedTotal;
        if (amount && amount > 0) {
          finalTotal = discountedTotal - amount;
        }
        finalTotal = Math.max(finalTotal, 0);
        setDiscountedTotal(finalTotal);
        setVoucherData(response.data);
        setVoucher_btn(false);
      }
    } catch (error) {
      errorAlert("invalid code");
    }
  };
  const fetchAllPlans = async () => {
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllPlans(data);
      const employeeData = response?.data?.map(
        (item: PlanResponse, i: number) => ({
          label: `${item.plan_name}`,
          value: item.id,
          item: item,
        })
      );
      setAllPlans(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const handleNatSelect = (option: any | null) => {
    setNewSelectedOption(option || undefined);
    setSelectedOption(undefined);
    setSelectedDisOption(undefined);
    getAllDistributor();
  };
  useEffect(() => {
    fetchAllEmployees();
    fetchAllPlans();
  }, [state]);

  const [newStatus, setNewStatus] = useState<any>(null);
  const handleChangeStatus = (data: { id: string; status: string }) => {
    const payload = {
      id: data.id,
      status: data.status,
    };
    setNewStatus(payload);
  };
  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <div>{text}</div>,
      sorter: (a: EmployeeData, b: EmployeeData) => a.key.localeCompare(b.key),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (_: any, record: EmployeeData) => (
        <div>{formatDate(record?.allDetails?.createdAt) || "--"}</div>
      ),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      render: (text: string) => text,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Email.localeCompare(b.Email),
    },

    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Parent Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{record?.allDetails?.distributer?.company_name || "N/A"}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Owner Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{"Distributer"}</div>
          </p>
        </div>
      ),
    },

    {
      title: "Plan Name",
      dataIndex: "planDetail",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{record.planDetail.plan_name}</div>
          </p>
        </div>
      ),
    },

    {
      title: "Plan Amount",
      dataIndex: "planDetail",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{record.planDetail.amount}</div>
          </p>
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: EmployeeData) => (
        <span className="dropdown">
          <Link
            to="#"
            className={`badge  btn btn-white ${text === "Active" ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </Link>
          <ul className="dropdown-menu dropdown-menu-end p-3">
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangeStatus({
                    id: record.allDetails.user_id,
                    status: "Active",
                  })
                }
              >
                Active
              </div>
            </li>
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangeStatus({
                    id: record.allDetails.user_id,
                    status: "InActive",
                  })
                }
              >
                InActive
              </div>
            </li>
          </ul>
        </span>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Status.localeCompare(b.Status),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="action-icon d-inline-flex">
          {userType === "master" && (
            <div
              style={{ cursor: "pointer" }}
              className="me-2"
              data-bs-toggle="modal"
              data-bs-target="#login_modal"
              onClick={() => login(record)}
            >
              <i className="fas fa-sign-in-alt" />
            </div>
          )}
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_employee"
            onClick={() => handleEdit(record.allDetails)}
          >
            <i className="ti ti-edit" />
          </Link>

          <Link
            to={`/ViewFinancers?financer_id=${encodeURIComponent(
              JSON.stringify(record.id)
            )}`}
          >
            <i className="ti ti-eye" />
          </Link>
        </div>
      ),
    },
  ];
  const [recordData, SetRecordData] = useState<any>();

  const [edit, setEdit] = useState(false);
  const [id, setId] = useState();
  const handleEdit = (data: any) => {
    setEdit(true);
    setId(data?.id);
    const parsedAddress = JSON.parse(data.address || {});
    setFormData((prevFormData) => ({
      ...prevFormData,
      full_name: data?.full_name,
      email: data?.email,
      phone_number: data?.phone_number,
      gst_no: data?.gst_number,
      cin_number: data?.cin_number,
      pan_number: data?.pan_number,
      company_name: data?.company_name,
    }));
    // setImage(data?.profile_pic);
    setAddress({
      addressLine: parsedAddress?.addressLine,
      city: parsedAddress?.city,
      states: parsedAddress?.states,
      country: parsedAddress?.country,
      pincode: parsedAddress?.pincode,
    });
  };

  const login = (data: any) => {
    SetRecordData(data);
  };

  const handleSubmitLogin = (event: React.FormEvent<HTMLFormElement>) => {
    const plan = recordData?.planDetail.discription;
    event.preventDefault();
    const loginData = sessionStorage.getItem("info");
    if (loginData) {
      localStorage.setItem("info", loginData);
      let change = "change";
      sessionStorage.setItem("changing", change);
      sessionStorage.setItem("plans", plan);
    }

    const payload = {
      id: recordData?.allDetails?.id,
      type: recordData?.allDetails?.type,
      user_id: recordData?.allDetails?.user_id,
      username: recordData?.allDetails?.full_name,
    };
    sessionStorage.setItem("info", JSON.stringify(payload));
    window.location.href = "/employee-dashboard";
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString);
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error);
    }
  }

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [forCreate, setNewFinancer] = useState<any>();
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const master_Id = mtId?.id || "0";
    if (!edit && password !== confirm_password) {
      errorAlert("password and confirm_password should be the same");
      return;
    }
    const requiredFields = [
      "email",
      "full_name",
      "company_name",
      "password",
      "phone_number",
      "prefix_code",
      "user_name",
    ];
    const editRequiredFields = ["email", "full_name", "phone_number"];
    const editedFields = edit ? editRequiredFields : requiredFields;
    const emptyFields = editedFields.filter(
      (field) => !formData[field as keyof typeof formData]?.trim()
    );

    if (emptyFields.length > 0) {
      console.error(
        `The following fields are empty: ${emptyFields.join(", ")}`
      );
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      );
      return;
    }
    const payloads = {
      address: address,
      email: formData.email,
      gst_number: formData.gst_no,
      full_name: formData.full_name,
      phone_number: formData.phone_number,
      company_name: formData.company_name,
      cin_number: formData.cin_number,
      pan_number: formData.pan_number,
      profile_pic: imageUrl,
    };
    if (edit) {
      const response = await updateFinancer(id, payloads);
      if (response.status === true) {
        successAlert("success", "successfully updated ");
        setImage(null);
        setEdit(false);
        setId(null);
        setFormData(initialValues);
        setAddress(addressState);
        fetchAllEmployees();
      }
      return;
    }

    const payload = {
      address: address,
      email: formData.email,
      gst_number: formData.gst_no,
      full_name: formData.full_name,
      password: formData.password,
      phone_number: formData.phone_number,
      prefix_code: formData.prefix_code,
      user_name: formData.user_name,
      company_name: formData.company_name,
      cin_number: formData.cin_number,
      pan_number: formData.pan_number,
      profile_pic: imageUrl,
      distributer_id: master_Id,
      type: "financer",
      plan_id: selectedOption?.value,
      discount_id: discountData?.id || null,
      voucher_id: voucherData?.id || null,
    };
    if (selectPaymentType?.value === "cheque") {
      if (!cheque_no || !cheque_date || !cheque_img) {
        errorAlert(
          "Please fill out the required fields: cheque_no, cheque_date, cheque_img"
        );
        return;
      }
      const newPayload = {
        ...payload,
        cheque_no: cheque_no,
        cheque_date: cheque_date,
        cheque_img: cheque_img,
      };
      const response = await submitChequeButton(newPayload);
      return;
    }

    if (selectedPlans.label === "Pre-Plan") {
      const newPayload = {
        ...payload,
        cheque_no: cheque_no,
        cheque_date: cheque_date,
        cheque_img: cheque_img,
      };
      const response = await submitChequeButton(newPayload);
      return;
    }

    const new_amt = voucherDiscountedTotal + discountedTotal;

    const paymentPayload = {
      name: formData.full_name,
      email: formData.email,
      mobile_number: formData.phone_number,
      plan: selectedOption.label,
      amount: discountedTotal > 0 ? discountedTotal : totalAmount,
      // amount: new_amt > 0 ? new_amt : totalAmount,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/payments/session`,
        paymentPayload,
        {
          method: "POST",
        }
      );

      const orderId = await response?.data?.data?.order_id;
      const payment_amount = await response?.data?.data?.amount;
      const newp = {
        ...payload,
        orderId: orderId,
        payment_amount: payment_amount,
      };
      if (response?.data?.status === true) {
        setNewFinancer(newp);
        setOpenModal(true);
      }
    } catch (err) {
      console.error("Payment Error:", err.message);
      alert("Failed to initialize payment");
    }
  };

  const submitChequeButton = async (new_data: any) => {
    try {
      setLoader(true);
      const response = await createNewFinancers(new_data);
      if (response.status === true) {
        setSelectedOption(undefined);
        setCoupon_Code("");
        setSuccessCreation(true);
        setImage(null);
        setFormData(initialValues);
        setDiscountData(undefined);
        setAddress(addressState);
        setCheque_date("");
        setSelectPaymentType(false);
        setCheque_no("");
        setCheque_img(null);
        fetchAllEmployees();
      }
    } catch (error) {
      errorAlert("error", `${error?.response?.data?.message}`);
    } finally {
      setLoader(false);
      setDiscountedTotal(0);
    }
  };
  const submitButton = async () => {
    try {
      setLoader(true);
      const response = await createNewFinancers(forCreate);
      if (response.status === true) {
        setSelectedOption(undefined);
        setCoupon_Code("");
        setSuccessCreation(true);
        setImage(null);
        setFormData(initialValues);
        setDiscountData(undefined);
        setAddress(addressState);
        fetchAllEmployees();
      }
    } catch (error) {
      errorAlert("error", `${error?.response?.data?.message}`);
    } finally {
      setLoader(false);
      setOpenModal(false);
      setDiscountedTotal(0);
    }
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Financers");
    XLSX.writeFile(workbook, "Financer List.xlsx");
  };

  const handleSubmitStatus = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    try {
      const payload = {
        status: newStatus?.status,
      };
      const response = await ChangeStatus(newStatus?.id, payload);
      if (response.status === true) {
        successAlert("success", `User Status Changed to ${newStatus?.status}`);
        fetchAllEmployees();
        setNewStatus(null);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };
  return (
    <>
      {(totalAmount > 0 || discountedTotal > 0) && openModal && (
        <RenderRazorpay
          orderId={forCreate?.orderId}
          amount={discountedTotal > 0 ? discountedTotal : totalAmount}
          submitButton={submitButton}
        />
      )}
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
              {typeof mtIdString === "string" &&
                JSON.parse(mtIdString)?.type === "distributer" && (
                  <div className="mb-2">
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-inert={true}
                      data-bs-target="#add_employee"
                      className="btn btn-primary d-flex align-items-center"
                      onClick={() => {
                        setEdit(false);
                        setFormData(initialValues);
                        setAddress(addressState);
                        setImage(null);
                      }}
                    >
                      <i className="ti ti-circle-plus me-2" />
                      Create New Financer
                    </Link>
                  </div>
                )}
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <CommonSearch
                    allEmployeeData={allEmployeeData}
                    setFilteredData={setFilteredData}
                  />
                </div>
                {/* <div> */}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent Role</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {newSelectedOption
                        ? newSelectedOption.label
                        : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departNational?.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleNatSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent User</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selecteddisOption
                        ? selecteddisOption.label
                        : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departSD?.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleNewSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {/* <li>
                        <div
                          onClick={exportToPDF}
                          className="btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </div>
                      </li> */}
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {filteredData && filteredData.length > 0 ? (
                  <Table
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  // rowSelection={{ type: "checkbox" }}
                  />
                ) : (
                  <p className="custom-cal-react " style={{ padding: "15px" }}>
                    No Data Found
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Financers</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation"></li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                            <i className="ti ti-photo text-gray-2 fs-16" />
                          </div>
                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 MB
                              </p>
                              {error && <p className="text-danger">{error}</p>}
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                {image ? "Replace" : "Upload"}
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {image && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="text"
                            name="full_name"
                            value={full_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            required
                            name="email"
                            value={email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            required
                            name="phone_number"
                            value={phone_number}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {!edit && (
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Loan Account Number Start Code
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="prefix_code"
                              required
                              value={prefix_code}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                      )}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Company Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="company_name"
                            value={company_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {!edit && (
                        <>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                user_name{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                required
                                type="text"
                                name="user_name"
                                value={user_name}
                                onChange={handleChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3 ">
                              <label className="form-label">
                                Password <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.password
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  required
                                  name="password"
                                  value={password}
                                  onChange={handleChange}
                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.password
                                      ? "ti-eye"
                                      : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("password")
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3 ">
                              <label className="form-label">
                                Confirm Password{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.confirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  required
                                  name="confirm_password"
                                  value={confirm_password}
                                  onChange={handleChange}
                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                      ? "ti-eye"
                                      : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("confirmPassword")
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            CIN No <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="cin_number"
                            value={cin_number}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Gst No <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="gst_no"
                            value={gst_no}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Pan No.<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="pan_number"
                            value={pan_number}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Address Line <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="addressLine"
                            value={addressLine}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            City <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="city"
                            value={city}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            State <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="states"
                            value={states}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Country <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="country"
                            value={country}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            PinCode <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="pincode"
                            value={pincode}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {!edit && (
                        <>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Select Plan</label>
                              <Select
                                classNamePrefix="react-select"
                                required
                                className="select"
                                options={allPlans}
                                value={selectedOption}
                                onChange={handlepSelect}
                                placeholder="Select Plan"
                              />
                              {selectedOption && (
                                <div className="mt-1">{`Plan + Subscribe Amount = ${totalAmount}`}</div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Discount Coupon Code
                              </label>
                              <input
                                type="text"
                                name="coupon_code"
                                value={coupon_code}
                                onChange={handleSelectDis}
                                className="form-control"
                              />
                            </div>
                            {coupon_btn && (
                              <div className="mb-3">
                                <button
                                  onClick={handleVerifyCode}
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                  className="btn btn-primary"
                                >
                                  Verify Coupon
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Voucher Code</label>
                              <input
                                type="text"
                                name="voucher_code"
                                value={voucher_code}
                                onChange={handleSelectVoucherDis}
                                className="form-control"
                              />
                            </div>
                            {coupon_btn1 && (
                              <div className="mb-3">
                                <button
                                  onClick={handleVerifyVoucherCode}
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                  className="btn btn-primary"
                                >
                                  Verify Voucher
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Total Payable Amount
                              </label>
                              <input
                                type="text"
                                value={
                                  discountedTotal >= 0
                                    ? discountedTotal
                                    : totalAmount
                                }
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Select Payment Type
                              </label>
                              <Select
                                classNamePrefix="react-select"
                                required
                                className="select"
                                options={[
                                  { value: "online", label: "Online" },
                                  { value: "cheque", label: "Cheque" },
                                ]}
                                value={selectPaymentType}
                                onChange={handlePaymentType}
                                placeholder="Select Payment Type"
                              />
                            </div>
                          </div>
                          {selectPaymentType?.value === "cheque" && (
                            <>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Cheque No{" "}
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="number"
                                    name="cheque_no"
                                    value={cheque_no}
                                    onChange={(e) =>
                                      setCheque_no(e.target.value)
                                    }
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Cheque Date{" "}
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="date"
                                    name="coupon_code"
                                    value={cheque_date}
                                    onChange={(e) =>
                                      setCheque_date(e.target.value)
                                    }
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="profile-upload">
                                  <div className="mb-2">
                                    <h6 className="mb-1">
                                      Upload Cheque Image{" "}
                                      <span className="text-danger"> *</span>
                                    </h6>
                                    <p className="fs-12">
                                      Image should be below 4 MB
                                    </p>
                                    {error && (
                                      <p className="text-danger">{error}</p>
                                    )}
                                  </div>
                                  <div className="profile-uploader d-flex align-items-center">
                                    <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                      {cheque_img ? "Replace" : "Upload"}
                                      <input
                                        type="file"
                                        className="form-control image-sign"
                                        accept="image/*"
                                        onChange={handleChequeFileChange}
                                      />
                                    </div>
                                    <Link
                                      to="#"
                                      className="btn btn-light btn-sm"
                                      onClick={() => setCheque_img("")}
                                    >
                                      Cancel
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                {cheque_img && (
                                  <div className="mt-1">
                                    <span>Preview:</span>
                                    <img
                                      src={cheque_img}
                                      alt="Profile Preview"
                                      className="img-thumbnail"
                                      style={{
                                        width: "200px",
                                        maxHeight: "150px",
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      // onClick={handleSubmit}
                      // data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Add Employee */}
      {/* Edit Employee */}

      <div className="modal fade" id="login_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Login</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitLogin}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to login</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Login{" "}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Employee */}
      {/* Add Employee Success */}
      <div className="modal fade" id="status_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Change Status</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitStatus}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to {newStatus?.status} this user</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default FinancersList;
